export const formatOptions = [
  { value: { height: 1050, width: 1480 }, label: "DIN A6" },
  { value: { height: 1480, width: 2100 }, label: "DIN A5" },
  { value: { height: 1250, width: 1760 }, label: "DIN B6" },
  { value: { height: 1050, width: 2100 }, label: "DIN lang" },
  { value: { height: 1000, width: 1000 }, label: "Quadrat (10x10cm)" },
  { value: { height: 1000, width: 1500 }, label: "Benutzerdefiniert" },
];
